import { VideoEditorSkeleton } from "components/Skeleton/MetadataPages/VideoEditorSkeleton";
import { setScrollBehavior } from "features/scrollPageBehaviorProvider/scrollPageBehaviorProvider";
import { VideoMetadataEditor } from "features/videoUploads/metadata/videoMetadataEditor";
import client from "libs/client";
import { useEffect } from "react";
import { useParams } from "react-router";
import "style/discoverPage.css";
import "style/videoMetadataPage.css";

export function VideoUploadMetadataPage() {
	const params = useParams();

	useEffect(() => {
		setScrollBehavior();
	}, []);

	// @ts-ignore
	const id = Number.parseInt(params.id);

	const { data: video, isLoading: videoLoading } = client.getVideo.useQuery({ id }, { queryKey: ["metadataVideos"], enabled: id !== undefined });
	if (!(video || videoLoading)) {
		return "NOT FOUND";
	}

	return (
		<div className="videoMetadataPage-container">
			{videoLoading ? (
				<VideoEditorSkeleton />
			) : (
				<VideoMetadataEditor video={video?.data} />
			)}
		</div>

	);
}
